import React, { useEffect, useState } from "react";
import FormikControl from "../../Components/LifeInsFormikComponent/FormikControl";
import { FieldArray, Form, Formik, useFormikContext } from "formik";
import _ from "lodash";
import CreateQuoteObject from "./CreateQuoteObject";

const CommunityArray = (props) => {
  // const [arrayField,setArrayField]=useState([])
  const { values } = useFormikContext();

  const {
    name,
    Field,
    page,
    memberObject,
    QualificationArray,
    setQualificationArray,
    documentArray,
    setdocumentArray,
    Marray,
    customErrors,
    nomineeShare,
    setNomineeShare,
    setCustomErrors,
  } = props;
  // console.log(name);

  //console.log('activeStep',Field)

  // console.log(name, "valuesinArrayname");

  const SplittedName = name.split(".");
  let subName = values;
  let Aindex;
  //console.log('sss',SplittedName,name)

  SplittedName.map((Sname, ind) => {
    //console.log(Sname, "Sname");
    if (Sname.indexOf("[") !== -1) {
      const splitedSname = Sname.split("[");
      Aindex = splitedSname[1][0];
      subName = subName[`${splitedSname[0]}`][`${splitedSname[1][0]}`];
      //console.log('Sub name',subName)
    } else {
      // console.log(subName,"subName",Sname)
      subName = subName[`${Sname}`];
    }
  });
  // console.log("arrays....",subName)
  const toAdd = subName[0];
  // var updatedMember={}
  // updatedMember=values.memberdetails[0]

  useEffect(() => {
    //   console.log()
    // console.log(values,"valuesinCommunityArray")
  }, []);

  return (
    <>
      <div>
        <div>
          <b>{Field.label}</b>
        </div>
        <div>
          {Object.keys(Field).length > 0 ? (
            <FieldArray
              name={name}
              render={(arrayHelpers) => {
                const { form } = arrayHelpers;

                const AddHandler = () => {
                  let obj = {};
                  if (Object.entries(toAdd).length > 0) {
                    Object.entries(toAdd).map((field, index) => {
                      obj[`${field[0]}`] = "";
                    });
                  }
                  //console.log(toAdd,"toAdd")
                  arrayHelpers.push(obj);
                };
                const DeleteHandler = (index_val) => {
                  arrayHelpers.remove(index_val);
                  
                };
                return (
                  <div>
                    {subName !== undefined ? (
                      <div>
                        {subName.length > 0 &&
                          subName.map((f, i) => {
                            const fieldName = Field.name;
                            const arrObjName = `${name}[${i}]`;
                            return (
                              <div id={name} key={i}>
                                {Field.obj.map((field, index) => {
                                  return field.htmlElement === "TextField" ? (
                                    <div
                                      className="mb-3"
                                      key={index}
                                      id={field.name}
                                      hidden={field.hidden}
                                    >
                                      <FormikControl
                                        control="input"
                                        name={`${arrObjName}.${field.name}`}
                                        manualValidation={
                                          field.manualValidation
                                        }
                                        errors={field.errors}
                                        readOnly={field.readOnly}
                                        url={field.url}
                                        label={field.label}
                                        type={field.dataType}
                                        arrayindex={i}
                                        DeleteHandler = {DeleteHandler}
                                        AddHandler={AddHandler}
                                        page={page}
                                        customErrors={customErrors}
                                        setCustomErrors={setCustomErrors}
                                        nomineeShare={nomineeShare}
                                        setNomineeShare={setNomineeShare}
                                      />
                                    </div>
                                  ) : field.htmlElement === "Select" ? (
                                    <div
                                      className="mb-3"
                                      key={index}
                                      hidden={field.hidden}
                                      id={field.name}
                                    >
                                      <FormikControl
                                        control="select"
                                        readOnly={field.readOnly}
                                        name={`${arrObjName}.${field.name}`}
                                        label={field.label}
                                        type={field.dataType}
                                        options={field.options}
                                        page={page}
                                        arrayIndex={i}
                                      />
                                    </div>
                                  ) : field.htmlElement === "TextArea" ? (
                                    <div
                                      className="mb-3"
                                      key={index}
                                      hidden={field.hidden}
                                      id={field.name}
                                    >
                                      <FormikControl
                                        control="textarea"
                                        name={`${arrObjName}.${field.name}`}
                                        label={field.label}
                                        type={field.dataType}
                                        page={page}
                                      />
                                    </div>
                                  ) : field.htmlElement === "Radio" ? (
                                    <div
                                      className="mb-3"
                                      key={index}
                                      hidden={field.hidden}
                                      id={field.name}
                                    >
                                      <FormikControl
                                        control="radio"
                                        name={`${arrObjName}.${field.name}`}
                                        dependent={field.dependent}
                                        options={field.options}
                                        manualValidation={
                                          field.manualValidation
                                        }
                                        label={field.label}
                                        type={field.dataType}
                                        // parent={arrObjName}
                                        // Qualification={Qualification}
                                        // docFile={docFile}
                                        Mparent={Field.name}
                                        page={page}
                                        // Aindex={i}
                                        array={i}
                                      />
                                    </div>
                                  ) : field.htmlElement === "DatePicker" ? (
                                    <div
                                      className="mb-3"
                                      key={index}
                                      hidden={field.hidden}
                                      id={field.name}
                                    >
                                      <FormikControl
                                        control="date"
                                        name={`${arrObjName}.${field.name}`}
                                        readOnly={field.readOnly}
                                        label={field.label}
                                        type={field.dataType}
                                        page={page}
                                      />
                                    </div>
                                  ) : field.htmlElement === "checkbox" ? (
                                    <div
                                      className="mb-3"
                                      key={index}
                                      hidden={field.hidden}
                                      id={field.name}
                                    >
                                      <FormikControl
                                        control="checkbox"
                                        name={`${arrObjName}.${field.name}`}
                                        label={field.label}
                                        type={field.dataType}
                                        options={field.options}
                                        page={page}
                                      />
                                    </div>
                                  ) : field.htmlElement === "File" ? (
                                    <div
                                      className="mb-3"
                                      key={index}
                                      hidden={field.hidden}
                                      id={field.name}
                                    >
                                      <FormikControl
                                        control="file"
                                        name={`${arrObjName}.${field.name}`}
                                        label={field.label}
                                        type={field.dataType}
                                        subName
                                        page={page}
                                      />
                                    </div>
                                  ) : field.htmlElement === "Object" ? (
                                    <div
                                      className="mb-3"
                                      key={index}
                                      hidden={field.hidden}
                                      id={`${arrObjName}.${field.name}`}
                                    >
                                      <CreateQuoteObject
                                        name={`${arrObjName}.${field.name}`}
                                        Field={field}
                                        // parent={arrObjName}
                                        // array={i}
                                        AddHandler={AddHandler}
                                        arrayIndex={i}
                                        Mparent={Field.name}
                                        Aindex={Aindex}
                                        page={page}
                                        customErrors={customErrors}
                                        setCustomErrors={setCustomErrors}
                                        nomineeShare={nomineeShare}
                                        setNomineeShare={setNomineeShare}
                                      />
                                    </div>
                                  ) : field.htmlElement === "Time" ? (
                                    <div
                                      className="mb-3"
                                      key={index}
                                      hidden={field.hidden}
                                      id={field.name}
                                    >
                                      <FormikControl
                                        control="time"
                                        // name={`${name}.${arrObjName}.${field.name}`}
                                        label={field.label}
                                        type={field.dataType}
                                        page={page}
                                      />
                                    </div>
                                  ) : null;
                                })}
                               {/*  <div className="f_delete_con">
                                  {//name === "HealthInsuranceDetails" ||
                                  i === 0 ? null : (
                                    <button
                                      className="family_add"
                                      type="button"
                                      onClick={() => DeleteHandler(i)}
                                    >
                                      - Remove
                                    </button>
                                  )}
                                </div> */}

                                {!(subName.length === i + 1) && (
                                  <div
                                    className="line"
                                    style={{
                                      width: "100%",
                                      border: "none",
                                      borderBottom: "1.5px solid #c4c4c4",
                                      margin: "1rem 0 1rem 0",
                                    }}
                                  ></div>
                                )}
                              </div>
                            );
                          })}
                      {/*   <div className="f_delete_con">
                          {name === "HealthInsuranceDetails" ||
                          name === "primaryDetails.PartnerRef" ||
                          name === "nomineeDetails" ? null : (
                            <button
                              className="family_add"
                              type="button"
                              onClick={AddHandler}
                            >
                              {name === "primaryDetails.Family"
                                ? "+ Add member"
                                : "+ Add One More"}
                            </button>
                          )}
                        </div> */}
                      </div>
                    ) : null}
                  </div>
                );
              }}
            ></FieldArray>
          ) : null}
        </div>
      </div>
    </>
  );
};
export default CommunityArray;
